import React from 'react'

// Original vectors from Figma frame 220, Group 6522: the chart title info icon.
const ChartInfoIcon = () => (
  <svg width={14} height={14} viewBox="326 192 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="333" cy="199" r="6.5" stroke="#BEC6D6" />
    <path d="M333 203.375V198.125" stroke="#BEC6D6" strokeWidth="1.5" />
    <path d="M333 196.812V195.5" stroke="#BEC6D6" strokeWidth="1.5" />
  </svg>
)

export default ChartInfoIcon
